module.exports = __webpack_public_path__ + "img/partnerHezuobg2.62266b5e.png";